import { sendRequest } from 'zoomforth_zfutils/xhr_tools.js';
import { toConfigApiModel } from 'zoomforth_codesbane_viewer/transformers/config_transformer.js';

import { markAsDraft } from './versioning.js';

import {
  makeSaveId,
  unblockSave,
  pendSave,
  sendSave,
  commitSave,
  failSave
} from 'zoomforth_shared_management/action_creators/saving.js';

import {
  notifyErrorMaybeLostData
} from './misc.js';

import {
  getPendingSave,
  getSendingOrBlockingSave,
  getEditorOnlySectionOverridesBySectionId
} from 'zoomforth_codesbane_editor/reducers/index.js';

import {
  getTranslationsCurrentLanguageIso,
  getTranslationsDefaultLanguageIso
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  ensureThrottledTranslationUpdate
} from './translations.js';


const PAGE_CONFIG_SAVE_DELAY = 1000; // Milliseconds


export const savePageConfig = ()=> 
  (dispatch, getState)=> {

    const state = getState();

    const { pageEntities } = state;

    const configModelData = toConfigApiModel({
      ...pageEntities,
      sectionOverridesBySectionId: getEditorOnlySectionOverridesBySectionId(state)
    });

    const defaultLanguageIso = getTranslationsDefaultLanguageIso(state);
    const currentLanguageIso = getTranslationsCurrentLanguageIso(state);
    const isEditingSecondaryLang = currentLanguageIso !== defaultLanguageIso;

    if (isEditingSecondaryLang) {
      dispatch(ensureThrottledTranslationUpdate());
    } else {
      const saveId = makeSaveId();
      dispatch(sendSave('page_config', saveId));

      sendRequest({

        url: `/api/page_content_items/${pageEntities.pageConfigId}`,
        method: 'PATCH',
        params: {
          ...configModelData,
          'is_editing_secondary_language': isEditingSecondaryLang
        },
        onSuccess: ()=> {

          dispatch(commitSave(saveId, { blockNext:true }));

          setTimeout(()=> {
            if (getPendingSave(getState(), 'page_config')) {
              dispatch(savePageConfig()); // Also unblocks
            } else {
              dispatch(unblockSave('page_config'));
            }

          }, PAGE_CONFIG_SAVE_DELAY);

          dispatch(ensureThrottledTranslationUpdate());
        },
        onError: ({ status, responseText })=> {
          dispatch(failSave(saveId));
          dispatch(notifyErrorMaybeLostData(status, responseText));
        }

      });
    }

  };


export const ensureThrottledPageConfigSaving = ()=>
  (dispatch, getState)=> {
    const state = getState();
    const defaultLanguageIso = getTranslationsDefaultLanguageIso(state);
    const currentLanguageIso = getTranslationsCurrentLanguageIso(state);
    const isEditingSecondaryLang = currentLanguageIso !== defaultLanguageIso;

    dispatch(markAsDraft());

    // we don't want to create a pending save in a secondary language since it
    // will never complete
    if (!isEditingSecondaryLang) {
      dispatch(pendSave('page_config', 'Save page config'));
    }

    if (!getSendingOrBlockingSave(getState(), 'page_config')) {
      dispatch(savePageConfig());
    }

  };
